<template>
  <div class="d-flex align-items-center">
    <span class="min-w-9rem me-3 text-center">
      <EditOnClick v-model="value.name" />
    </span>
    <a :href="href" target="_blank" class="btn btn-secondary btn-sm">
      <BaseIcon name="web" />
    </a>
    <span class="me-1 min-w-2rem text-center">
      <BaseIcon name="posts-tag" />
      <div>
        {{ value.posts_count ?? "-" }}
      </div>
    </span>
    <span class="me-1 min-w-2rem text-center">
      <BaseIcon name="comments-tag" />
      <div>
        {{ value.comments_count ?? "-" }}
      </div>
    </span>
    <span class="min-w-2rem text-center">
      <BaseIcon name="like-tag" />
      <div>
        {{ value.likes_count ?? "-" }}
      </div>
    </span>
  </div>
</template>

<script>
import BaseIcon from "../../icons/BaseIcon";
import EditOnClick from "../../inputs/EditOnClick.vue";
export default {
  name: "IntegrationStatisticsBlock",
  components: { EditOnClick, BaseIcon },
  props: {
    id: Number,
    type: String,
    row: Object,
    modelValue: Object,
  },
  data() {
    return {
      value: this.modelValue,
    };
  },
  computed: {
    href() {
      if (this.value?.name === null || this.value?.name === undefined) {
        return null;
      }
      let baseUrl = "";
      if (this.row.row_key === "facebook") {
        baseUrl = "https://facebook.com/";
      } else if (this.row.row_key === "instagram") {
        baseUrl = "https://instagram.com/";
      } else if (this.row.row_key === "tiktok") {
        baseUrl = "https://www.tiktok.com/@";
      }
      return baseUrl + this.value?.name;
    },
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.$emit("update:modelValue", this.value);
        this.$emit("change", this.value);
        this.$emit("update", this.value);
      },
    },
    modelValue() {
      this.value = this.modelValue;
    },
  },
  methods: {},
  emits: ["update:modelValue", "change"],
};
</script>
